import { TravelExpenseRef } from "../../../../../../models/travel-expenses";
import { Page } from "../../../../../../models/api/page";
import {
  SortByQuickFilter,
  SORT_BY_QF_NAMES,
} from "../../../../../../containers/Quickfilters/SortByQuickfilter/interfaces";
import { TravelExpenseDTO } from "src/models/travel-expenses/travel-expense-dto";

export const HEADER_BLOCK_CLASSNAME = "header_block";

export const filterTravelExpenses = (travelExpenses: TravelExpenseDTO[], page: Page, sortModel: SortByQuickFilter) => {
  if (!travelExpenses.length) return [];

  const { name, direction } = sortModel.sortByOptions.sortBy[0];

  const travelExpensesToFilter = [...travelExpenses];

  travelExpensesToFilter.sort((a, b) => {
    if (name === SORT_BY_QF_NAMES.amount) {
      return direction === 1 ? (b.amount ?? 0) - (a.amount ?? 0) : (a.amount ?? 0) - (b.amount ?? 0);
    }

    if (name === SORT_BY_QF_NAMES.date) {
      return direction === 1
        ? new Date(b.date).getTime() - new Date(a.date).getTime()
        : new Date(a.date).getTime() - new Date(b.date).getTime();
    }

    if (name === SORT_BY_QF_NAMES.country) {
      const country1 = (a.country?.name ?? "").toLowerCase();
      const country2 = (b.country?.name ?? "").toLowerCase();

      if (country1 < country2) {
        return direction === 1 ? 1 : -1;
      }
      if (country1 > country2) {
        return direction === 1 ? -1 : 1;
      }
    }

    if (name === SORT_BY_QF_NAMES.description) {
      const descr1 = (a.description ?? "").toLowerCase();
      const descr2 = (b.description ?? "").toLowerCase();

      if (descr1 < descr2) {
        return direction === 1 ? 1 : -1;
      }
      if (descr1 > descr2) {
        return direction === 1 ? -1 : 1;
      }
    }

    if (name === SORT_BY_QF_NAMES.type) {
      const type1 = (a.type?.name ?? "").toLowerCase();
      const type2 = (b.type?.name ?? "").toLowerCase();

      if (type1 < type2) {
        return direction === 1 ? 1 : -1;
      }
      if (type1 > type2) {
        return direction === 1 ? -1 : 1;
      }
    }

    if (name === SORT_BY_QF_NAMES.auditAccepted) {
      if (direction === 1) {
        // Order: true > false > null
        if (a.auditAccepted === b.auditAccepted) return 0;
        if (a.auditAccepted === null) return 1;
        if (b.auditAccepted === null) return -1;
        if (a.auditAccepted === true) return -1;
        if (b.auditAccepted === true) return 1;
      } else {
        // Order: null > false > true
        if (a.auditAccepted === b.auditAccepted) return 0;
        if (a.auditAccepted === null) return -1;
        if (b.auditAccepted === null) return 1;
        if (a.auditAccepted === false) return -1;
        if (b.auditAccepted === false) return 1;
      }
    }

    if (name === SORT_BY_QF_NAMES.modifiedAt) {
      if (a.modifiedAt && b.modifiedAt) {
        return direction === 1
          ? new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime()
          : new Date(a.modifiedAt).getTime() - new Date(b.modifiedAt).getTime();
      }

      if (!a.modifiedAt && b.modifiedAt) {
        return direction === 1 ? 1 : -1;
      }

      if (a.modifiedAt && !b.modifiedAt) {
        return direction === 1 ? -1 : 1;
      }

      if (!a.modifiedAt && !b.modifiedAt) {
        return 0;
      }
    }

    return 0;
  });

  return travelExpensesToFilter.slice(page.pageNumber * page.pageSize, (page.pageNumber + 1) * page.pageSize);
};
